import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserPermissionsService } from '../core/user-permissions/user-permissions.service';
import { ToasterService } from '../shared/services/toaster.service';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent implements OnInit {
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userPermissionsService: UserPermissionsService,
        private toaster: ToasterService
    ) {}

    ngOnInit() {
        if (this.route.snapshot.firstChild == null) {
            this.router.navigate(['restricted-product']);
        }
        // this.toggleMultipleOwnerWarning();
    }

    // toggleMultipleOwnerWarning(): void {
    //     this.userPermissionsService.getUserOrganizationsWithMultipleOwner().subscribe((resultArray) => {
    //         const list = resultArray.filter((item) => {
    //             return item.hasMultipleOwners === false;
    //         });
    //         if (list.length > 0) {
    //             this.toaster.eject(
    //                 `Please add an additional owner to organization(s): ${list.map(
    //                     (l) => l.name
    //                 )} to ensure continuity of management for your organization!`,
    //                 'Warning',
    //                 {
    //                     type: 'warning',
    //                     vertical: 'top',
    //                     horizontal: 'right',
    //                 }
    //             );
    //         }
    //     });
    // }
}
